import axios from "axios";
import { fAlertToast } from "../Utility/Utilitys";
import { getGlobals } from "../Configs";
export const axiosInstance = axios.create({
  // baseURL: `${process.env.REACT_APP_BASE_URL_TEST}`,
  baseURL: `${getGlobals().API_BASE_URL}`,
  responseType: "json",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

export const httpRequest = async (axiosData, loaderScreen = true) => {
  const loader = document.getElementById("loader");
  try {
    if (loaderScreen) {
      loader.style.display = "flex";
    }
    const res = await axiosInstance.request(axiosData);
    loader.style.display = "none";
    return res?.data;
  } catch (error) {
    // if (
    //   error.response &&
    //   error.response.data &&
    //   error.response.data.Type === "Failed"
    // ) {
    //   // handled error at server
    //   fAlertToast("FAILED", error.response.data.Status);
    // } else {
    //   fAlertToast("FAILED", error.message);
    // }
    loader.style.display = "none";
    throw error;
  }
};

export const httpRequest_001 = async (axiosData) => {
  const loader = document.getElementById("loader");
  try {
    loader.style.display = "flex";
    const res = await axiosInstance.request(axiosData);
    loader.style.display = "none";
    return res?.data;
  } catch (error) {
    const loader = document.getElementById("loader");
    loader.style.display = "none"; // Hid
    console.log(error);
    fAlertToast("FAILED", error?.response?.data?.message || error.message);
    // throw error;
  }
};

export const httpRequest_002 = async (axiosData, loaderScreen = true) => {
  const loader = document.getElementById("loader");

  try {
    if (loaderScreen) {
      loader.style.display = "flex";
    }
    const res = await axiosInstance.request(axiosData);
    loader.style.display = "none";

    return res;
  } catch (error) {
    loader.style.display = "none";
    console.log(error?.response?.data?.message);

    if (
      (error?.response &&
        error?.response?.data &&
        error?.response?.data?.Type?.toUpperCase() === "FAILED") ||
      error?.response?.data?.Type === "Validation"
    ) {
      // handled error at server
      fAlertToast("FAILED", error.response.data.Status);
    } else {
      fAlertToast(
        "FAILED",
        error?.response?.data?.message?.msg ||
          error?.response?.data?.message ||
          error?.response?.data ||
          error?.response?.status ||
          error?.message ||
          error?.Message
      );
    }
    return error;
    // throw error;
  }
};

export const httpRequest_003 = async (axiosData) => {
  const loader = document.getElementById("loader");
  try {
    loader.style.display = "flex";
    const res = await axiosInstance.request(axiosData);
    loader.style.display = "none";

    return res;
  } catch (error) {
    loader.style.display = "none";
    return error;
    // throw error;
  }
};

export const getGeoLocation = async () => {
  // const res  = await axios.get("https://geolocation-db.com/json/");
  // const res = await axios.get("https://api.ipify.org/?format=json");
  // console.log("REsREs", res);
  // if (res) {
  //   // return res?.data?.IPv4 || "";
  //   return res?.data?.ip || "";
  // } else {
  //   return "";
  // }

  try {
    const res = await axios.get("https://api.ipify.org/?format=json");
    return res?.data?.ip || "";
  } catch (error) {
    console.log("GeoLocation API failed:", error);
    return ""; // Fallback value if API fails
  }
};

// export const httpRequestUrl = async (axiosData) => {
//   try {
//     const res = await axiosInstance.request(axiosData);
//     return res;
//   } catch (error) {
//     //handleError(error.message, true);
//     throw error;
//   }
// };
